import React, { useState } from "react";
import { X } from "lucide-react";

const SelectionDropdown = ({
  title,
  label,
  selectedItems,
  availableItems,
  loading,
  searchTerm,
  onSearchChange,
  formFieldName,
  formValues,
  setValue,
  getItemDisplayName,
  getItemId,
  itemType = "items", // "users" or "customers"
  showDropdown: externalShowDropdown,
  setShowDropdown: externalSetShowDropdown
}) => {
  const [internalShowDropdown, setInternalShowDropdown] = useState(false);
  const showDropdown = externalShowDropdown !== undefined ? externalShowDropdown : internalShowDropdown;
  const setShowDropdown = externalSetShowDropdown !== undefined ? externalSetShowDropdown : setInternalShowDropdown;

  const handleRemoveItem = (itemId) => {
    const current = formValues[formFieldName] || [];
    const itemIdStr = itemId.toString();
    const newValue = current.filter(id => id.toString() !== itemIdStr);
    setValue(formFieldName, newValue, { shouldDirty: true });
  };

  const handleToggleItem = (itemId, checked) => {
    const current = formValues[formFieldName] || [];
    const itemIdStr = itemId.toString();
    const currentIds = current.map(id => id.toString());
    
    if (checked) {
      // Only add if not already in the list (prevent duplicates)
      if (!currentIds.includes(itemIdStr)) {
        setValue(formFieldName, [...current, itemIdStr]);
      }
    } else {
      setValue(formFieldName, current.filter(id => id.toString() !== itemIdStr));
    }
  };

  const filteredItems = availableItems.filter(item => {
    const displayName = getItemDisplayName(item).toLowerCase();
    return displayName.includes(searchTerm.toLowerCase());
  });

  return (
    <div className="form-section">
      <span className="section-title">{title}</span>
      <div className="form-field">
        <label htmlFor={formFieldName} className="form-label">
          {label}
        </label>
        
        {selectedItems.length > 0 && (
          <div className="selected-items-list">
            {selectedItems.map((item) => {
              const itemId = getItemId(item);
              return (
                <div key={itemId} className="selected-item-tag">
                  <span>{getItemDisplayName(item)}</span>
                  <button
                    type="button"
                    className="remove-tag-button"
                    onClick={() => handleRemoveItem(itemId)}
                  >
                    <X size={14} />
                  </button>
                </div>
              );
            })}
          </div>
        )}

        <button
          type="button"
          className="toggle-dropdown-button"
          onClick={() => setShowDropdown(!showDropdown)}
        >
          {showDropdown ? 'Hide' : 'Show'} {itemType === "users" ? "User" : "Customer"} List
          <span className={`dropdown-arrow ${showDropdown ? 'open' : ''}`}>▼</span>
        </button>

        {showDropdown && (
          <div className="customers-dropdown">
            {loading ? (
              <p>Loading {itemType}...</p>
            ) : (
              <>
                <input
                  type="text"
                  className="search-input"
                  placeholder={`Search ${itemType}...`}
                  value={searchTerm}
                  onChange={(e) => onSearchChange(e.target.value)}
                />
                <div className="customers-list">
                  {filteredItems.map((item) => {
                    const itemId = getItemId(item);
                    const isSelected = (formValues[formFieldName] || []).some(
                      id => id.toString() === itemId
                    );
                    return (
                      <label key={itemId} className="customer-checkbox-item">
                        <input
                          type="checkbox"
                          checked={isSelected}
                          onChange={(e) => handleToggleItem(itemId, e.target.checked)}
                        />
                        <span>{getItemDisplayName(item)}</span>
                      </label>
                    );
                  })}
                  {filteredItems.length === 0 && (
                    <div className="no-results">No {itemType} found</div>
                  )}
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectionDropdown;

